import { createSlice } from '@reduxjs/toolkit';
import { assumeEmployeeRole } from '../employees/employeesActions';
import {
  getUserDetails,
  registerUser,
  updatePassword,
  updateProfileImage,
  updateUserDetail,
  userLogin,
} from './userActions';

const userToken = localStorage.getItem('userToken')
  ? localStorage.getItem('userToken')
  : null;

const initialState = {
  loading: false,
  userInfo: null, // for user object
  userToken, // for storing the JWT
  isAssumed: false,
  assumedUserInfo: null,
  assumedUserToken: null,
  error: null,
  success: false, // for monitoring the registration process.
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    assume: (state, { payload }) => {
      state.isAssumed = true;
      state.assumedUserInfo = payload.data;
      state.assumedUserToken = payload.headers.authorization;
    },
    unAssume: (state, { payload }) => {
      localStorage.setItem('userToken', state.userToken);
      state.isAssumed = false;
      state.assumedUserInfo = null;
      state.assumedUserToken = null;
    },
    logout: state => {
      localStorage.removeItem('userToken'); // deletes token from storage
      state.loading = false;
      state.userInfo = null;
      state.userToken = null;
      state.error = null;

      state.isAssumed = false;
      state.assumedUserInfo = null;
      state.assumedUserToken = null;
    },
  },
  extraReducers: {
    // login user
    [userLogin.pending]: state => {
      state.loading = true;
      state.error = null;
    },
    [userLogin.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.userInfo = payload.data;
      state.userToken = payload.headers.authorization;
    },
    [userLogin.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // register user
    [registerUser.pending]: state => {
      state.loading = true;
      state.error = null;
    },
    [registerUser.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true; // registration successful
    },
    [registerUser.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // get user
    [getUserDetails.pending]: state => {
      state.loading = true;
    },
    [getUserDetails.fulfilled]: (state, { payload }) => {
      state.loading = false;
      if (state.isAssumed) {
        state.assumedUserInfo = payload.data;
      } else {
        state.userInfo = payload.data;
      }
    },
    [getUserDetails.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // update user
    [updateUserDetail.pending]: state => {
      state.loading = true;
    },
    [updateUserDetail.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [updateUserDetail.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // update password
    [updatePassword.pending]: state => {
      state.loading = true;
    },
    [updatePassword.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [updatePassword.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // update image
    [updateProfileImage.pending]: state => {
      state.loading = true;
    },
    [updateProfileImage.fulfilled]: (state, { payload }) => {
      state.loading = false;
      // state.userInfo.image = payload.image
    },
    [updateProfileImage.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // assume role
    [assumeEmployeeRole.pending]: state => {},
    [assumeEmployeeRole.fulfilled]: (state, { payload }) => {
      localStorage.setItem('userToken', payload.headers.authorization);
      state.isAssumed = true;
      state.assumedUserInfo = payload.data;
      state.assumedUserToken = payload.headers.authorization;
    },
    [assumeEmployeeRole.rejected]: (state, { payload }) => {
      state.error = payload;
    },
  },
});

export const { logout, assume, unAssume } = userSlice.actions;
export default userSlice.reducer;
